import type { NavBarAuthSourceConfig } from './useNavBarAuthHandlers.types';

import queryString from 'utils/query-string';

export const formatNavBarAuthRoute = ({
  route,
  query = {}
}: Pick<NavBarAuthSourceConfig, 'route' | 'query'>) => `${route}?${queryString.stringify(query)}`;
